/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_TagInputs */

const en_gc_resources_guide_analysis_tag = /** @type {(inputs: Gc_Resources_Guide_Analysis_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analysis`)
};

const zh_gc_resources_guide_analysis_tag = /** @type {(inputs: Gc_Resources_Guide_Analysis_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分析`)
};

/**
* | output |
* | --- |
* | "Analysis" |
*
* @param {Gc_Resources_Guide_Analysis_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_tag = /** @type {((inputs?: Gc_Resources_Guide_Analysis_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_tag(inputs)
	return zh_gc_resources_guide_analysis_tag(inputs)
});
export { gc_resources_guide_analysis_tag as "gc.resources.guide.analysis.tag" }